import React from 'react';
import BaseMixin from '../common/base-mixin.js';
import ElementaryMixin from '../common/elementary-mixin.js';
import LsiMixin from '../common/lsi-mixin.js';
import NestingLevelMixin from '../common/nesting-level-mixin.js';
import Environment from './../environment/environment.js';
//import {FloatMixin} from '../layout/layout.js';
import {P, Glyphicon, Div} from './bricks.js';


import './home-screen.less'

export const HomeScreen = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    //FloatMixin,
    LsiMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.HomeScreen',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-home-screen'
    },
    defaults: {
      reSmartURL: /\/ath(\/)?$/,
      reQueryString: /([\?&]ath=[^&]*$|&ath=[^&]*(&))/,
      lsi: () => (Environment.Lsi.Bricks.homeScreen),
      defaultSession: {
        lastDisplayTime: 0, // last time we displayed the message
        returningVisitor: false, // is this the first time you visit
        displayCount: 0, // number of times the message has been shown
        //optedout: false, // has the user opted out
        added: false // has been actually added to the homescreen
      }
    },
    opt: {
      nestingLevelRoot: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    appID: React.PropTypes.string,		// local storage name
    skipFirstVisit: React.PropTypes.bool,		// show only to returning visitors (ie: skip the first time you visit)
    startDelay: React.PropTypes.number,				// display the message after that many seconds from page load
    lifespan: React.PropTypes.number,				// life of the message in seconds
    displayPace: React.PropTypes.number,			// minutes before the message is shown again (0: display every time, default 24 hours)
    maxDisplayCount: React.PropTypes.number,			// absolute maximum number of times the message will be shown to the user (0: no limit)
    message: React.PropTypes.any,				// the message can be customized
    detectHomescreen: React.PropTypes.oneOf(['hash', 'query', 'smart', false])		// try to detect if the site has been added to the homescreen (false | true | 'hash' | 'queryString' | 'smartURL')
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      appID: 'uu5.homescreen',
      skipFirstVisit: false,
      startDelay: 1000,
      lifespan: 5000,
      displayPace: 1440,
      maxDisplayCount: 0,
      message: '',
      detectHomescreen: 'hash',
      // autostart: true,			// show the message automatically
      // debug: false,				// override browser checks
      // logging: false,				// log reasons for showing or not showing to js console; defaults to true when debug is true
      // modal: false,				// prevent further actions until the message is closed
      // mandatory: false,			// you can't proceed if you don't add the app to the homescreen
      // icon: true,					// add touch icon to the message
      // validLocation: [],			// list of pages where the message will be shown (array of regexes)
      // onInit: null,				// executed on instance creation
      // onShow: null,				// executed when the message is shown
      // onRemove: null,				// executed when the message is removed
      // onAdd: null,				// when the application is launched the first time from the homescreen (guesstimate)
      // onPrivate: null,			// executed if user is in private mode
      // privateModeOverride: false,	// show the message even in private mode (very rude)
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    return {
      receiveProps: false
    };
  },

  componentWillMount: function () {
    this.hide();
  },

  componentDidMount: function () {
    var homeScreen = this;
    if (!this.props.hidden) {
      setTimeout(function () {
        homeScreen.activate();
      }, this.props.startDelay < 0 ? 1 : this.props.startDelay);
    }
  },

  componentWillReceiveProps: function (nextProps) {
    // cannot set visibility by receive props
    this.setState({hidden: this.isHidden()});
  },

  componentWillUnmount: function () {
    this.hiddenTimeout && clearTimeout(this.hiddenTimeout);
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  activate: function (setStateCallback) {
    var shouldRender = this._shouldRender();
    // console.error("activate", shouldRender);
    if (shouldRender) {
      var homeScreen = this;

      this.setHiddenValue(false, function () {
        homeScreen.hiddenTimeout && clearTimeout(homeScreen.hiddenTimeout);
        homeScreen.hiddenTimeout = setTimeout(function () {
          homeScreen.hide(setStateCallback);
        }, homeScreen.props.lifespan);
      });
    }
    return this;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMobileOS: function () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var os = 'unknown';

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      os = "windowsPhone";

    } else if (/android/i.test(userAgent)) {
      os = "android";

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      os = "iOS";
    }

    return os;
  },

  _hasToken: function () {
    // console.error("_hasToken", document.location.hash === '#ath', this.getDefault().reSmartURL.test(document.location.href), this.getDefault().reQueryString.test(document.location.search))
    return document.location.hash === '#ath' ||
      this.getDefault().reSmartURL.test(document.location.href) ||
      this.getDefault().reQueryString.test(document.location.search);
  },

  _isMobileIOS: function () {
    return this._getMobileOS() === 'iOS';
  },

  _isMobileAndroid: function () {
    return this._getMobileOS() === 'android';
  },

  _isSafari: function () {
    var userAgent = window.navigator.userAgent;
    return this._isMobileIOS() && userAgent.indexOf('Safari') > -1 && userAgent.indexOf('CriOS') === -1;
  },

  _isChrome: function () {
    var userAgent = window.navigator.userAgent;
    return (/Chrome\/[.0-9]*/).test(userAgent) && userAgent.indexOf("Version") === -1;
  },

  _isAndroidChrome: function () {
    return this._isMobileAndroid() && this._isChrome();
  },

  _isCompatibleEnvironment: function () {
    return (this._isSafari() && this._getMobileOSVersion() >= 6) || this._isAndroidChrome();
  },

  _isStandAloneMode: function () {
    return !!window.navigator.standalone;
  },

  _getBrowserLanguage: function () {
    return window.navigator.language ? window.navigator.language.toLowerCase() : 'en';
  },

  _getMobileOSVersion: function () {
    var version = window.navigator.userAgent.match(/(OS|Android|Windows Phone) (\d+[_\.]\d+)/);
    return version && version[2] ? +version[2].replace('_', '.') : 0;
  },

  _isTablet: function () {
    var userAgent = window.navigator.userAgent;
    return (this._isSafari() && userAgent.indexOf('iPad') > -1) || (this._isAndroidChrome() && userAgent.indexOf('Mobile') === -1);
  },

  _shouldRender: function () {
    var shouldRender = false;

    // load session
    var session = this._getAppSession();

    // user most likely came from a direct link containing our token, we don't need it and we remove it
    if (this._hasToken() && (!this._isCompatibleEnvironment() || (!session && !this.props.detectHomescreen))) {
      this._removeToken();
    }

    // the device is supported
    if (this._isCompatibleEnvironment()) {
      session = session || this.getDefault().defaultSession;
      this._setAppSession(session);

      var now = Date.now();
      if (this._checkSession(session) && this._checkShowing(session, now)) {
        this._incrementDisplayCount(session, now);
        shouldRender = true;
      }
    }

    return shouldRender;
  },

  _checkSession: function (session) {
    // if is added at homescreen
    if (session.added) {
      return false;
    }

    // check if the app is in stand alone mode
    if (this._isStandAloneMode()) {
      session.added = true;
      this._setAppSession(session);
      return false;
    }

    // (try to) check if the page has been added to the homescreen
    if (this.props.detectHomescreen) {
      // the URL has the token, we are likely coming from the homescreen
      if (this._hasToken()) {
        this._removeToken(); // we don't actually need the token anymore, we remove it to prevent redistribution

        // this is called the first time the user opens the app from the homescreen
        session.added = true;
        this._setAppSession(session);
        return false;
      }

      // URL doesn't have the token, so add it
      this._addToken();
    }

    // check if this is a returning visitor
    if (!session.returningVisitor) {
      session.returningVisitor = true;
      this._setAppSession(session);

      // we do not show the message if this is your first visit
      if (this.props.skipFirstVisit) {
        return false;
      }
    }

    return true;
  },

  _getSession: function (item) {
    var session;
    if (localStorage) {
      session = localStorage.getItem(item);
      session && (session = JSON.parse(session));
    }
    return session || null;
  },

  _setSession: function (item, session) {
    localStorage && localStorage.setItem(item, JSON.stringify(session));
    return this;
  },

  _getAppSession: function () {
    return this._getSession(this.props.appID);
  },

  _setAppSession: function (session) {
    this._setSession(this.props.appID, session);
    return this;
  },

  _addToken: function () {
    // console.error("add token", this.props.detectHomescreen == 'hash');
    if (this.props.detectHomescreen == 'hash') {
      document.location.hash !== '#ath' && history.replaceState('', window.document.title, document.location.href + '#ath');
    } else if (this.props.detectHomescreen == 'smart') {
      history.replaceState('', window.document.title, document.location.href.replace(/(\/)?$/, '/ath$1'));
    } else {
      history.replaceState('', window.document.title, document.location.href + (document.location.search ? '&' : '?') + 'ath=');
    }
    return this;
  },

  _removeToken: function () {
    if (document.location.hash == '#ath') {
      history.replaceState('', window.document.title, document.location.href.split('#')[0]);
    }

    if (this.getDefault().reSmartURL.test(document.location.href)) {
      history.replaceState('', window.document.title, document.location.href.replace(this.getDefault().reSmartURL, '$1'));
    }

    if (this.getDefault().reQueryString.test(document.location.search)) {
      history.replaceState('', window.document.title, document.location.href.replace(this.getDefault().reQueryString, '$2'));
    }

    return this;
  },

  _checkShowing: function (session, date) {
    var lastDisplayTime = session.lastDisplayTime;

    // we obey the display pace (prevent the message to popup too often)
    var showing = date - lastDisplayTime > this.props.displayPace * 60000;

    // obey the maximum number of display count
    showing = showing && (this.props.maxDisplayCount === 0 || session.displayCount < this.props.maxDisplayCount);

    return showing;
  },

  _incrementDisplayCount: function (session, date) {
    // increment the display count
    session.lastDisplayTime = date;
    session.displayCount++;
    this._setAppSession(session);
    return this;
  },

  _getMessage: function () {
    // var languages = Tools.sortLanguages(this._getBrowserLanguage());
    var message;
    var messages;

    if (this.props.message) {
      if (typeof this.props.message === 'object') {
        message = this.props.message[this._getMobileOS()];
        if (!message) {
          messages = this.getLSIItem(this.props.message);
        }
      } else {
        message = this.props.message;
      }
    } else {
      let lsi = this.getDefault().lsi();
      messages = this.getLSIItem(lsi);
    }

    messages && (message = messages[this._getMobileOS()]);

    message = message && message.replace(/%icon(?:\[([^\]]+)\])?/gi, function (matches, group1) {
        return '<span className="ath-action-icon">' + (!!group1 ? group1 : 'icon') + '</span>';
      });

    return message;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    let message = this._getMessage();

    let visibility = this.isHidden() ? ' uu5-bricks-home-screen-hidden' : ' uu5-bricks-home-screen-shown';
    // console.log('render', visibility);

    let containerProps = {
      className: 'ath-container ath-' + this._getMobileOS()
      + ' ath-' + this._getMobileOS() + (parseInt(this._getMobileOSVersion()) || '')
      + ' ath-' + (this._isTablet() ? 'tablet' : 'phone')
      + visibility
    };

    return (
      <Div className="ath-viewport" nestingLevel={this.getNestingLevel()}>
        <div {...containerProps}>
          <div onClick={() => this.hide()}>
            <Glyphicon glyphicon="uu-glyphicon-cross"/>
          </div>
          <P content={message}/>
        </div>
      </Div>
    );
  }
  //@@viewOff:render
});

export default HomeScreen;



// WEBPACK FOOTER //
// ./bricks/home-screen.js